import { orchestrator } from 'satcheljs';
import { setCalendarDisplayOrder } from '../actions/setCalendarDisplayOrder';
import getCalendarWithDisplayOrderRESTService from '../services/getCalendarWithDisplayOrderRESTService';
import { trace } from 'owa-trace';
import { getCalendarEntryByCalendarId, updateCalendarEntry } from 'owa-calendar-cache';

/**
 * The action worker which handles setting of the calendar display order.
 */
export default orchestrator(setCalendarDisplayOrder, async actionMessage => {
    const { userIdentity, calendarId } = actionMessage;

    try {
        const serviceResponse = await getCalendarWithDisplayOrderRESTService(
            userIdentity,
            calendarId
        );

        if (serviceResponse) {
            let entry = getCalendarEntryByCalendarId(calendarId);
            updateCalendarEntry(entry.calendarId.id, {
                DisplayOrder: serviceResponse.DisplayOrder,
            });
        } else {
            trace.warn('Unable to set calendar display order.');
        }
    } catch (error) {
        trace.warn('Unable to set calendar display order.');
        return;
    }
});
